import React from 'react'
import styled, { css } from 'styled-components'

import Table from 'components/Table'

import { PictureAsPdfOutlined } from '@mui/icons-material'

import GA4 from 'helpers/ga4'

import Resource from 'types/Resource'

type Props = {
  resource: Resource
}

const HelpResourceRow = ({ resource }: Props) => {
  const onClickLink = (name) => {
    GA4.sendEvent({
      category: 'Resources',
      action: 'Article Viewed',
      label: name
    })
  }

  if (resource == null) {
    return <></>
  }

  return (
    <S.TableRow key={resource.name}>
      <S.NameCell>
        <S.Link
          href={resource.url}
          onClick={() => {
            onClickLink(resource.name)
          }}
          target="_blank"
          rel="noreferrer"
        >
          <S.PictureAsPdfOutlined />
          {resource.name}
        </S.Link>
      </S.NameCell>

      <S.DescriptionCell>
        {resource.description}
      </S.DescriptionCell>

      <S.DateCell>
        {resource.createdAt}
      </S.DateCell>
    </S.TableRow>
  )
}
export default HelpResourceRow

const cellStyle = css`
  padding: 15px;
`

const S = {
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  `,
  Link: styled.a`
    display: contents;
  `,
  NameCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: center;
    flex-basis: 25%;
  `,
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 25%;
  `,
  PictureAsPdfOutlined: styled(PictureAsPdfOutlined)`
    margin: 5px;
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
  `
}
